import { defineComponent as _defineComponent } from 'vue'

import { getCurrentInstance, ref, watch } from "vue";
import { ElLoading } from "element-plus";

const __default__ = {
  name: "GlobalFullScreenLoading",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  text: { type: String, default: "" },
},
  setup(__props) {

const props = __props

const { proxy } = getCurrentInstance();


let _text = ref<string>(props.text);
let LOADING_INSTANCE: any;

watch(
  () => props.text,
  (newVal) => {
    _text.value = newVal;
  }
);
watch(
  () => proxy.$api.$status.hasIndicatingStatus,
  (newVal) => {
    fullScreenLoading(newVal);
  }
);
const fullScreenLoading = (val: boolean): void => {
  if (val) {
    LOADING_INSTANCE = ElLoading.service({
      lock: true,
      text: props.text ? props.text : "加载中...",
      background: "rgba(0, 0, 0, 0.7)",
    });
  } else {
    LOADING_INSTANCE.close();
    //   this.fullScreenLoadingText = "";
  }
};

return (_ctx: any,_cache: any) => {
  return null
}
}

})